import React, { useEffect, useState, useCallback } from 'react';
import loadable from '@loadable/component';

import useCartState, { useCartActions, useRewardsModalState } from '../../../hooks/useCartState';
import useDeviceInfo from '../../../hooks/useDeviceInfo';
import { Helpers } from '../../../core/src/helpers';

const RewardsModal = loadable(() => Helpers.retryFunc(() => import('./rewards-modal')));
const RewardsRedeem = loadable(() => Helpers.retryFunc(() => import('./rewards-redeem')));

import './rewards-info.less';

const setTemplateVars = (html, templateVars) => {
    //template vars are in the format [varName]
    return html.replace(/\[(.*?)\]/g, (match, p1) => {
        return templateVars[p1];
    });
};

export default ({ palatizedShipping, csrActions }) => {
    const { device } = useDeviceInfo(['device'], 'default');
    const [bannerHtml, setBannerHtml] = useState(null);
    const { getRewardsBanner } = useCartActions();
    const { cartInfo } = useCartState();
    const { cartView } = cartInfo || {};
    const { x_isLoyaltyEnrolled, x_userType, x_isLoyaltyProductPresent, x_hpRewardsTC: hpRewardsTC } = cartView || {};
    const { rewardsModalState: modalType, setRewardsModalState } = useRewardsModalState();
    const isLoggedIn = x_userType === 'R';
    const isLoyaltyEnrolled = x_isLoyaltyEnrolled === 'true';
    const hideForMobile = (!isLoggedIn || !isLoyaltyEnrolled) && device === 'mobile';
    useEffect(() => {
        if (!x_isLoyaltyEnrolled || !x_userType) {
            return;
        }
        getRewardsBanner(isLoggedIn, isLoyaltyEnrolled).then(response => {
            const [html = null] = response || [];
            if (html) {
                setBannerHtml(html);
            }
        });
    }, [cartView, isLoyaltyEnrolled, isLoggedIn]);

    const clickHandler = useCallback(e => {
        //check if target has data attribute data-visid-reward-id that equals hpRewardsJoinVISIDModal
        const { dataset } = e.target || {};
        const { visidRewardId, action, gtmAction } = dataset || {};
        if (visidRewardId === 'hpRewardsJoinVISIDModal') {
            const modalAction = action || gtmAction === 'create-account' ? 'create' : gtmAction;
            //open modal
            setRewardsModalState(modalAction);
        }
    }, []);
    const closeModal = useCallback(() => {
        setRewardsModalState(null);
    }, []);
    if (!bannerHtml || x_isLoyaltyProductPresent === 'false') {
        return null;
    }
    const bannerContent = setTemplateVars(bannerHtml, { hpRewardsTC });
    const bannerElement = isLoyaltyEnrolled ? (
        <RewardsRedeem bannerHtml={bannerContent} palatizedShipping={palatizedShipping} csrActions={csrActions} />
    ) : (
        <div
            className="rewards-info"
            onClick={clickHandler}
            dangerouslySetInnerHTML={Helpers.createMarkup(bannerContent)}
        />
    );
    return (
        <>
            {modalType && <RewardsModal type={modalType} onClose={closeModal} termsLink={hpRewardsTC} />}
            {!hideForMobile && bannerElement}
        </>
    );
};
